mutation ConfirmMaterialUpload($input: ConfirmMaterialUploadInput!) {
  confirmMaterialUpload(input: $input) {
    id
    url
    displayName
    assetType
  }
}
